export { Kbd, type KbdProps } from './styled/kbd'
